import { render, staticRenderFns } from "./StartButtonsContainer.vue?vue&type=template&id=47cbb23a&"
import script from "./StartButtonsContainer.vue?vue&type=script&lang=js&"
export * from "./StartButtonsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports